export default "__VITE_ASSET__C5s1Q5LX__"